// Web-only "what to do with the captured PNG" step for the post-session
// share card (RW-18 follow-up, 2026-08-18). The capture itself is the shared
// <ShareCardRenderer>'s <ViewShot> (react-native-view-shot ships a real web
// backend, verified cross-platform — see packages/ui/src/Logger/
// ShareCardRenderer.tsx's header comment); this file is the one piece that
// genuinely differs per platform, same seam split as confirm.ts.
//
// Tries the Web Share API with a real file attachment first (native-feeling
// on the mobile browsers most likely to actually use this from a phone);
// falls back to a plain browser download when the API or file sharing isn't
// available (desktop Firefox/Safari today). Mirrors the Blob + createObjectURL
// + <a download> shape AccountScreen.tsx already uses for JSON export.

type ShareNavigator = Navigator & {
  share?: (data: { files?: File[]; title?: string }) => Promise<void>;
  canShare?: (data: { files?: File[] }) => boolean;
};

export async function shareOrDownloadPng(
  dataUrl: string,
  filename: string,
  title: string,
): Promise<void> {
  const blob = await (await fetch(dataUrl)).blob();
  const file = new File([blob], filename, { type: "image/png" });

  const nav = navigator as ShareNavigator;
  if (nav.share && nav.canShare?.({ files: [file] })) {
    await nav.share({ files: [file], title });
    return;
  }

  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
